export const createInitialState = (ticket, initialStake) => ({
  stake: initialStake,
  stakeInput: initialStake.toString(),
  balls: ticket.balls ?? [],
  repeatForDraws: ticket.repeat_for_draws ?? 1,
  acceptOddsChanges: ticket.change_odds_agreement ?? true,
  isEditingStake: false,
  validationError: null,
  addToCartError: null,
});

export const ticketReducer = (state, action) => {
  switch (action.type) {
    case 'SET_STAKE':
      return { ...state, stake: action.payload };
    case 'SET_STAKE_INPUT':
      return { ...state, stakeInput: action.payload };
    case 'SET_BALLS':
      return { ...state, balls: action.payload };
    case 'SET_REPEAT_FOR_DRAWS':
      return {
        ...state,
        repeatForDraws: action.payload,
        acceptOddsChanges: action.payload === 1 ? true : state.acceptOddsChanges,
      };
    case 'SET_ACCEPT_ODDS_CHANGES':
      return { ...state, acceptOddsChanges: action.payload };
    case 'SET_IS_EDITING_STAKE':
      return { ...state, isEditingStake: action.payload };
    case 'TOGGLE_STAKE_EDITING':
      return { ...state, isEditingStake: !state.isEditingStake };
    case 'SET_VALIDATION_ERROR':
      return { ...state, validationError: action.payload };
    case 'SET_ADD_TO_CART_ERROR':
      return { ...state, addToCartError: action.payload };
    case 'CLEAR_ERRORS':
      return { ...state, validationError: null, addToCartError: null };
    case 'RESET':
      return action.payload;
    default:
      return state;
  }
};
